"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const monocle_ts_1 = require("monocle-ts");
const fp = require("fp-ts");
const Actions = require("../../actionTypes/project/users");
const initialOrderByOptions = {
    orderBy: 'name',
    order: 'desc'
};
//#region STATE
exports.initialState = {
    userList: [],
    searchString: '',
    sortingAndPagination: {
        offset: 0,
        limit: 20,
        sortBy: 'name',
        order: 'asc'
    },
    status: 'STANDBY',
    error: null,
    orderByOptions: Object.assign({}, initialOrderByOptions),
    filterOptions: {}
};
//#endregion
//#region LENSES
const userListLens = monocle_ts_1.Lens.fromProp('userList');
const errorLens = monocle_ts_1.Lens.fromProp('error');
const limitLens = monocle_ts_1.Lens.fromPath([
    'sortingAndPagination',
    'limit'
]);
const offsetLens = monocle_ts_1.Lens.fromPath([
    'sortingAndPagination',
    'offset'
]);
const sortByLens = monocle_ts_1.Lens.fromPath([
    'sortingAndPagination',
    'sortBy'
]);
const orderLens = monocle_ts_1.Lens.fromPath([
    'sortingAndPagination',
    'order'
]);
const filterOptionsLens = monocle_ts_1.Lens.fromProp('filterOptions');
const statusLens = monocle_ts_1.Lens.fromProp('status');
const methods = {};
exports.methods = methods;
// Fetching
methods[Actions.FETCH_PROJECT_USER_LIST_REQUEST] = (state, action) => {
    return statusLens.set('FETCHING')(state);
};
methods[Actions.FETCH_PROJECT_USER_LIST_SUCCESS] = (state, action) => {
    const { users } = action.payload;
    const formattedUsers = users.map((user) => {
        const name = `${user.firstName ? `${user.firstName} ` : ''}${user.lastName ? user.lastName : ''}`;
        const address = `${user.addressDetails.street ? user.addressDetails.street + ', ' : ''}` +
            `${user.addressDetails.postalCode
                ? `${user.addressDetails.postalCode} `
                : ''}` +
            `${user.addressDetails.city ? user.addressDetails.city : ''}`;
        return {
            name,
            address,
            telephone: user.addressDetails.telephone || '',
            company: user.company || '',
            avatar: user.avatar,
            email: user.email || '',
            title: user.addressDetails.title || ''
        };
    });
    return fp.function.compose(userListLens.set(formattedUsers), statusLens.set('FETCHED'))(state);
};
methods[Actions.FETCH_PROJECT_USER_LIST_FAILURE] = (state, action) => {
    return fp.function.compose(errorLens.set(action.payload), statusLens.set('FAILED'))(state);
};
methods[Actions.SET_LIMIT] = (state, action) => limitLens.set(action.payload.limit)(state);
methods[Actions.SET_OFFSET] = (state, action) => offsetLens.set(action.payload.offset)(state);
methods[Actions.SET_ORDER_BY_OPTIONS] = (state, action) => fp.function.compose(sortByLens.set(action.payload.orderBy), orderLens.set(action.payload.order))(state);
methods[Actions.SET_FILTER_OPTIONS] = (state, action) => filterOptionsLens.modify((filters) => {
    const copy = Object.assign({}, filters);
    if (action.payload.value) {
        copy[action.payload.filter] = action.payload.value;
    }
    else {
        delete copy[action.payload.filter];
    }
    return copy;
})(state);
methods[Actions.CLEAR_STATE] = (state, action) => (Object.assign({}, exports.initialState));
//# sourceMappingURL=users.js.map